import { NgModule } from '@angular/core';
import { UserHasPermissionDirective } from './directive/user-has-permission.directive';
import { UserRoleService } from './services/user-role.service';
import { AppPracticePermissionDirective } from './directive/app-practice-permission.directive';
import { TaskPermissionDirective } from './directive/task-permission.directive';
import { ReportPermissionDirective } from './directive/report-permission.directive';
import { ReferralPermissionDirective } from './directive/patient-referral-permission.directive';

const PERMISSION_DIRECTIVES = [
  UserHasPermissionDirective,
  AppPracticePermissionDirective,
  TaskPermissionDirective,
  ReportPermissionDirective,
  ReferralPermissionDirective
];

@NgModule({
  declarations: [
    ...PERMISSION_DIRECTIVES
  ],
  imports: [
  ],
  providers: [UserRoleService],
  exports: [
    ...PERMISSION_DIRECTIVES
  ]
})
export class UserFeatureCoreModule { }
